import { React, useState, useEffect } from 'react'
import { useFetchText } from '../../hooks/useFetchText'

const usePolicyAttestation = () => {
  const [isChecked, setChecked] = useState(false)
  const [isContinueClicked, setContinueClicked] = useState(false)
  const requester = JSON.parse(window.localStorage.getItem('requester'))
  const policyversion = requester?.policyversion ?? null
  const { data: notification, loading } = useFetchText('notification.json')
  const currentVersion = notification?.CURRENT_POLICY_VERSION
  const [isPolicyAttested, setPolicyAttestation] = useState(false)

  const userPolicyAttested = window.localStorage.getItem(`userPolicyAttested for userid ${requester?.userid}`)

  useEffect(() => {
    if (!loading && currentVersion)
      setPolicyAttestation(policyversion !== currentVersion)

    if (userPolicyAttested !== null) setPolicyAttestation(false)

  }, [loading, currentVersion, policyversion])

  const onCheckChanged = (e) => {
    setChecked(e.target.checked)
    setContinueClicked(false)
  }

  const onContinueClick = () => {
    setContinueClicked(true)
    if (isChecked === false) return
    requester.policyversion = currentVersion
    fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/getuserprivacypolicy`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        requester: JSON.stringify(requester),
      },
      withCredentials: true,
      credentials: 'include',
    })
      .then((response) =>  {
        if (response.ok)
          window.localStorage.setItem(`userPolicyAttested for userid ${requester.userid}`, 'true')
      })
      .then((data) => {       
      })
      .catch((err) => {})
    setPolicyAttestation(false)
  }

  const onClose = () => setPolicyAttestation(false)

  return {
    isPolicyAttested,
    isChecked,
    isContinueClicked,
    onCheckChanged,
    onContinueClick,
    onClose,
  }
}

export default usePolicyAttestation
